module.exports = __webpack_public_path__ + "img/chat-bg.a576395b.png";